import { Stack } from '@grubhubprod/gh-cookbook-react';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { InsightsDashboardLoader } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsDashboardLoader/InsightsDashboardLoader';
import { InsightsDashboardWrapper } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsDashboardWrapper/InsightsDashboardWrapper';
import { useBusinessInsightsContext } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/hooks/useBusinessInsightsContext';
import { getConfig } from 'src/utilities/config';

export function InsightsDashboardSection(): JSX.Element {
  const {
    authorizationKey,
    authorizationToken,
    dashboardId,
    isLoading: isDashboardConfigLoading,
    isError,
  } = useBusinessInsightsContext();

  const [isDashboardLoading, setIsDashboardLoading] = useState(
    isDashboardConfigLoading
  );

  const config = getConfig();

  const dashboardConfig = useMemo(() => {
    if (!authorizationKey || !authorizationToken || !dashboardId || isError) {
      return null;
    }

    return {
      authKey: authorizationKey,
      authToken: authorizationToken,
      dashboardId,
      apiHost: config.luzmo.apiHost,
      appServer: config.luzmo.appServer,
    };
  }, [
    authorizationKey,
    authorizationToken,
    dashboardId,
    isError,
    config.luzmo.apiHost,
    config.luzmo.appServer,
  ]);

  const onLoaded = useCallback(() => {
    setIsDashboardLoading(false);
  }, []);

  const showLoader = isDashboardConfigLoading || isDashboardLoading;

  useEffect(() => {
    if (isDashboardConfigLoading) {
      setIsDashboardLoading(isDashboardConfigLoading);
    } else if (isError) {
      setIsDashboardLoading(false);
    }
  }, [isDashboardConfigLoading, isError]);

  return (
    <Stack y={showLoader ? 'md' : 'none'}>
      {showLoader && <InsightsDashboardLoader variant="compact" />}
      {!!dashboardConfig && (
        <InsightsDashboardWrapper
          dashboardConfig={dashboardConfig}
          onLoaded={onLoaded}
          isDashboardLoading={isDashboardLoading}
        />
      )}
    </Stack>
  );
}
